(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/category/components/featured-game-desktop.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/category/components/featured-game-desktop.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const trackPlay = svs.eInstant.tracking.trackPlay;
const RibbonCorner = svs.ui.ReactRibbon.RibbonCorner;
const ImageMemo = svs.eInstant.shared.components.ImageMemo;
const FeaturedGameDesktop = _ref => {
  var _featuredGame$tags;
  let featuredGame = _ref.featuredGame;
  const Button = svs.ui.ReactButton;
  const history = useHistory();

  if (!svs.eInstant.util.validateFeaturedGame(featuredGame)) {
    return null;
  }
  const handleClickPlay = e => {
    if (svs.tur.PauseCheck.isBlocked()) {
      svs.tur.apierrors.showErrorMessage({
        response: {
          error: {
            code: 1019
          }
        }
      });
      return;
    }
    e.preventDefault();
    trackPlay(featuredGame.name, false);
    history.push(featuredGame.playUrl);
  };
  const handleClickDemoPlay = e => {
    e.preventDefault();
    trackPlay(featuredGame.name, true);
    history.push(featuredGame.demoUrl);
  };
  return React.createElement("div", {
    className: "u-position-relative margin-bottom-4",
    "data-testid": "featured-game-desktop"
  }, React.createElement(ImageMemo, {
    cssSelectors: "featured-games-background-height",
    fitWrapper: true,
    image: featuredGame.featuredGameImage,
    loadingLazy: true
  }), React.createElement("div", {
    className: "relative f-body u-top-0"
  }, React.createElement("div", {
    className: "u-flex u-flex-row tickets-einstant-max-width featured-game-flex-direction-column-screen-md u-flex-justify-content-between u-flex-align-items-center"
  }, React.createElement("div", {
    className: "tickets-einstant-category-featured-games border-box u-position-relative bg-fler-lotter-new-500 align-center padding-h-4 padding-v-4 margin-bottom-2 u-flex u-flex-column"
  }, featuredGame.badge && React.createElement(RibbonCorner, {
    className: "ribbon-corner-featured-game",
    size: 700
  }, featuredGame.badge), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center u-flex-grow-1"
  }, React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-300 margin-bottom-1"
  }, featuredGame.name), React.createElement("p", {
    className: "f-400 margin-bottom-1 fc-fler-lotter-new-300 clip tickets-einstant-category-featured-game-tags"
  }, (_featuredGame$tags = featuredGame.tags) === null || _featuredGame$tags === void 0 ? void 0 : _featuredGame$tags.join(', ')), React.createElement("p", {
    className: "p margin-bottom-3 line-height-150 fc-fler-lotter-new-400 clip tickets-einstant-category-featured-game-description"
  }, featuredGame.description), React.createElement("div", {
    className: "u-flex u-flex-column margin-bottom-2 tickets-einstant-button-theme"
  }, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    onClick: handleClickPlay
  }, "Spela"), React.createElement(Button, {
    block: true,
    className: "margin-bottom-half",
    onClick: handleClickDemoPlay,
    transparent: true
  }, "Provspela")), React.createElement("div", {
    className: "u-flex u-flex-row u-flex-align-items-center u-flex-justify-content-between"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("p", {
    className: "p margin-bottom-half fc-fler-lotter-new-300"
  }, "Insats"), React.createElement("h4", {
    className: "h4 f-bold fc-fler-lotter-new-300 margin-0"
  }, featuredGame.maxPrice ? "".concat(featuredGame.minPrice, " - ").concat(featuredGame.maxPrice, " kr") : "".concat(featuredGame.minPrice, " kr"))), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("p", {
    className: "p margin-bottom-half fc-fler-lotter-new-300"
  }, "Maxvinst"), React.createElement("h4", {
    className: "h4 f-bold fc-fler-lotter-new-300 margin-0"
  }, "".concat(svs.utils.format.Currency(featuredGame.maxWin), " kr")))))), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center u-flex-justify-content-center"
  }, React.createElement("div", {
    className: "tickets-einstant-category-featured-game-logotype-desktop u-flex u-flex-align-items-center u-flex-justify-content-center padding-2"
  }, featuredGame.logotype && React.createElement(ImageMemo, {
    cssSelectors: "padding-half",
    image: featuredGame.logotype,
    loadingLazy: true,
    sizes: "(min-width: 1357px) 1000px, (min-width: 1024px) 800px, calc(100vw - 48px)"
  })), featuredGame.featuredGameImageOverlay && React.createElement("div", {
    className: "einstant-feature-games-image-overlay u-hide"
  }, React.createElement(ImageMemo, {
    fitWrapper: true,
    image: featuredGame.featuredGameImageOverlay,
    loadingLazy: true,
    sizes: "(min-width: 1357px) 700px, 600px"
  }))))));
};
setGlobal('svs.eInstant.lobby.category.components.FeaturedGameDesktop', FeaturedGameDesktop);

 })(window);